/**
 * Решения Марата с пояснением (М-1, backend/app/services/tender_feedback.py). Чистые функции
 * без DOM: правило обязательности категории и комментария, отклонение Цены1 от рекомендованной.
 */

export const AGREE_DEVIATION_PCT = 10;

export const REASON_LABEL = {
  agree: 'Согласие с рекомендацией',
  price_up_risks: 'Цена выше: риски',
  price_up_scope: 'Цена выше: объём работ',
  price_down_competition: 'Цена ниже: конкуренция',
  reject_topic: 'Отказ: не наша тема',
  reject_amount: 'Отказ: сумма',
  reject_customer: 'Отказ: заказчик',
  reject_terms: 'Отказ: условия и сроки',
  other: 'Другое',
};

export const GO_REASONS = ['price_up_risks', 'price_up_scope', 'price_down_competition', 'other'];
export const NO_GO_REASONS = ['reject_topic', 'reject_amount', 'reject_customer', 'reject_terms', 'other'];

/** Отклонение Цены1 от рекомендованной, % (число) или null. */
export function deviationPct(price, recommended) {
  const p = Number(price);
  const r = Number(recommended);
  if (price == null || price === '' || recommended == null || !Number.isFinite(p) || !(r > 0)) return null;
  return Math.round(((p - r) / r) * 10000) / 100;
}

/** «+12,5 %» / «−3 %» / «0 %». */
export function fmtDeviation(dev) {
  if (dev == null) return '';
  const abs = Math.abs(dev).toLocaleString('ru-RU', { maximumFractionDigits: 1 });
  return `${dev > 0 ? '+' : dev < 0 ? '−' : ''}${abs} %`;
}

/**
 * Почему нужны категория и комментарий; '' — согласие, бэкенд запишет agree сам.
 * Правило то же, что у POST /decision.
 */
export function reasonRequired(decision, dev, recommendation) {
  if (decision === 'no_go') return 'отказ';
  if (dev == null) return 'нет рекомендованной цены';
  if (Math.abs(dev) > AGREE_DEVIATION_PCT) return `Цена участия отличается от рекомендованной на ${fmtDeviation(dev)}`;
  if (recommendation === 'no_go') return 'раскладка рекомендовала отказ';
  return '';
}

/**
 * Проверка формы перед отправкой: текст ошибки или null.
 * category — выбранная категория ('' — не выбрана), comment — текст.
 */
export function validateDecision(decision, { dev, recommendation, category, comment }) {
  const allowed = decision === 'go' ? GO_REASONS : NO_GO_REASONS;
  if (category && category !== 'agree' && !allowed.includes(category)) {
    return `Категория «${REASON_LABEL[category]}» не подходит к решению «${decision === 'go' ? 'Участвуем' : 'Отказ'}»`;
  }
  const why = reasonRequired(decision, dev, recommendation);
  if (!why) return null;
  const missing = [];
  if (!category || category === 'agree') missing.push('категорию причины');
  if (!comment?.trim()) missing.push('комментарий');
  return missing.length ? `Укажите ${missing.join(' и ')}: ${why}` : null;
}
